// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/LoginFlow.tsx
// v3.39.0 - Hinweis im Schritt Firma wieder raus (Inhaber 02.11.2026: "gesonderte Sachen, die normalerweise nicht
//           vorkommen" - wer sich verirrt, steigt spaetestens bei Stripe aus).
// v3.38.0 - Schritt Firma: Hinweis "Arbeitet deine Firma schon mit estata? Dann lass dich ... einladen" (Inhaber
//           02.11.2026 - eine Mitarbeiterin hatte sich eine zweite Firma angelegt); gleicher Satz fuer jeden.
// v3.37.0 - E-Mail-Schritt ohne "Passwort vergessen?" (Inhaber 01.11.2026) - das steht erst beim Passwort.
// v3.36.0 - "Nicht du?" und "Passwort vergessen?" klebten aneinander (Inhaber 27.10.2026, Screenshot): eine Zeile,
//           "Nicht du?" links, "Passwort vergessen?" rechts - auf jedem Schritt rechtsbuendig unter dem Feld.
// v3.35.0 - HIG-Pruefung (Inhaber 27.10.2026: "allgemeine Anmeldung ... mit HIG-Doktor"): verdeckte Schritte sind fuer
//           VoiceOver und Tastatur stumm (inert + aria-hidden - vorher las VoiceOver jeden Schritt darunter mit),
//           Bestaetigungsblatt als Dialog (alertdialog, Fokus auf "Bestaetigen", Escape = Zurueck), Textlinks und
//           "Aendern" mit 44 px Tippflaeche ohne das Layout zu schieben, zu viele Versuche/gesperrt auf Deutsch statt
//           Servertext, Return-Taste der Tastatur "Weiter"/"Los" (enterKeyHint).
// v3.34.0 - Nach dem Bestaetigen direkt in die NEUE Firma: der Server nennt ihren Kurznamen, rememberFirm merkt ihn
//           (wer schon andere Firmen hat, landete sonst in der Auswahl oder in der alten).
// v3.33.0 - Konto erstellen ohne Subdomain (Inhaber 21.10.2026: "erstmal ohne Subdomain, nur app.estata.com" - Strato
//           kennt keine *.app-Eintraege): Schritt Firma nur Firmenname + AGB, den Kurznamen bildet der Server.
// v3.32.0 - Firma aus der Subdomain (firmName, ?firm=): ueber Anmelden und Passwort steht der Firmenname, nach der
//           Anmeldung geht es direkt in diese Firma (preferFirm), sonst wie bisher.
// v3.31.0 - Nachname Pflicht (Inhaber 21.10.2026: "Sonst ist das nicht serioes"): Schritt Name geht erst mit Vor- UND
//           Nachname weiter, beide Felder required.
// v3.30.0 - Konto erstellen naiv (Inhaber 21.10.2026: "der Registrierungsprozess muss komplett naiv sein"): ueber
//           "Konto erstellen" fragt die Seite NICHT, ob es die Adresse gibt; Reihenfolge E-Mail -> Passwort -> Name ->
//           Firma + Subdomain (+ AGB) -> "Schau in dein Postfach". Angelegt wird erst ueber den Link aus der Mail
//           (?signup=, Schritt reg-confirm: Passwort -> bestaetigt -> angemeldet). Fehler des Servers springen zum
//           Schritt mit dem Feld (field) und nennen den Grund (Passwort zu bekannt/aus Name, Adresse vergeben) statt
//           "Bitte alle Pflichtfelder korrekt ausfuellen". Nachname wirklich optional. Design unveraendert.
// v3.29.0 - onSignedIn: KI-App verbinden (/login?oauth=, OAuthConsent) - nach dem Passwort zurueck zur Zustimmung statt
//           Passcode/Bereich (Inhaber 18.10.2026, Migration 268).
// v3.28.0 - Passcode festlegen in InlineScreen: der Ziffernblock fuellt den Schritt (faehrt mit ihm ein), statt einen
//           eigenen Vollbildrahmen aufzumachen (@estata/ui 3.1.0).
// v3.27.0 - Passcode festlegen ohne eigenes Bild: die PIN-Seite zeigt immer das Login-Bild (@estata/ui 3.0.0).
// v3.26.0 - Bild beim Festlegen vom Server (MyEST-Einstellungen der Person, fetchPersonBackground).
// v3.25.0 - Passcode festlegen wieder mit abgedunkeltem Bild (MyEST-Bild der Person, sonst Login-Bild); nach dem
//           Speichern bleibt der Bildschirm stehen, bis der Bereich da ist.
// v3.24.1 - Bestaetigungsblatt durchsichtiger: Deckkraft 72 % -> 50 % (Inhaber, 12.10.2026: "etwas mehr transparent").
// v3.24.0 - Passcode festlegen schwarz, ohne Hintergrundbild (Inhaber, 12.10.2026).
// v3.23.0 - Eingabefelder aus @estata/ui (FloatingField/PasswordField): dieselbe Formlogik wie das Passcode-Tor in
//           MyEST; das X steht jetzt auch im Passwortfeld neben dem Auge (Inhaber, 12.10.2026).
// v3.22.0 - Bestaetigungsblatt: Adresse in einer Zeile (Schrift passt sich an), leicht durchsichtig mit Unschaerfe;
//           Texte ohne 'ESTATA' ('mit deinem Konto verbunden', Inhaber 12.10.2026).
// v3.21.0 - Passcode festlegen mit Bild dahinter (wie die Login-Seite), Glas-Tasten wie am iPhone (@estata/ui 1.3.0).
// v3.20.0 - Passcode je Geraet (Inhaber, 12.10.2026, Revolut-Vorbild; docs/website-login-concept.md C-2/C-3/C-5):
//           ist die Adresse bekannt, schiebt sich das Bestaetigungsblatt hoch ("Ist dies die E-Mail-Adresse ...?",
//           Bestaetigen / Zurueck). Nach der Anmeldung legt die Person auf diesem Geraet einen vierstelligen Passcode
//           fest (PasscodeSetup aus @estata/ui, POST /auth/passcode), sofern das Geraet noch keinen hat; danach ist die
//           App entsperrt (markUnlocked). Die zuletzt angemeldete Adresse steht beim naechsten Mal vorbelegt unter
//           "Willkommen zurueck", "Nicht du?" leert sie (lib/rememberEmail).
// v3.19.0 - Mitarbeiter-Einladung (Onboarding aus MyEST) ueber DASSELBE Fenster wie die Projektbeteiligten (Inhaber,
//           12.10.2026): lib/invitation.ts ist die Tuer (Planstar oder System), das Fenster sieht nur InviteInfo;
//           ablehnen nur bei Projektbeteiligten. Vorher fuehrte der Link auf eine eigene, leere Seite.
// v3.18.1 - Einladung an ein bestehendes Konto: Ueberschrift 'Hallo X, melde dich mit deinem Passwort an, dann wird
//           das Projekt verknuepft' statt 'vergib ein Passwort'; der gleichlautende Hinweis darunter entfaellt.
// v3.18.0 - Einladung an ein bestehendes Konto (Inhaber, 11.10.2026): mehrere Firmen -> 'Fuer welche Firma nimmst
//           du teil?' (E-5, companies/org_id); 'Einladung ablehnen' mit Rueckfrage (E-6, POST .../decline) - wer
//           eingeladen hat, bekommt eine Nachricht. Die Begruessung nennt den Namen aus dem Konto (E-2, Backend).
// v3.17.1 - Einladung an ein Konto mit Passwort: nur dieses Passwort, dazu "Passwort vergessen?" (Inhaber,
//           10.10.2026: kein neues Passwort, wenn die Person schon eines hat).
// v3.17.0 - Viewport-Mechanik (v3.16.x, NutriScan-Vorbild) ZURUECKGENOMMEN (Inhaber, 10.10.2026: "mach das einfach
//           rueckgaengig ... dann schiebt er mir meinetwegen den Bildschirm etwas hoch. Wir machen das dann, wenn
//           die Huelle kommt"). Rahmen wieder schlicht fixed inset-0; die Tastatur darf die Seite schieben. Es
//           bleibt: kein autoFocus, Tastatur zu vor jedem Wechsel, Fehler am Feld, Stapel, schwebende Beschriftung.
// v3.16.2 - iOS-App-Modus: html/body/Rahmen = Schirm MINUS Tastatur, exakt wie NutriScan (v3.16.1 setzte dort die
//           volle Schirmhoehe - das Dokument wurde hoeher als der geschrumpfte Viewport, iOS scrollte zum Feld und
//           der ganze Rahmen rutschte hoch; Inhaber, 10.10.2026: "Was ist das?"). Im Browser bleibt der Rahmen
//           innerHeight hoch (Schwarz unter der durchscheinenden Tastaturleiste).
// v3.16.1 - Schwarz bleibt unter der Tastatur (Inhaber, 10.10.2026: "Das ist Mist" - hinter der durchscheinenden
//           Tastaturleiste kam das Startbild durch, weil der Rahmen an der Tastatur endete). Jetzt zwei Ebenen:
//           der Rahmen deckt den ganzen Schirm schwarz ab, nur der Inhaltsbereich darin ist der sichtbare Ausschnitt.
// v3.16.0 - Tastatur wie in der NutriScan-App (flutter/web/index.html, Inhaber, 10.10.2026: "bei Dart hat das
//           super funktioniert"): der Rahmen wird auf den SICHTBAREN Ausschnitt geschrumpft (visualViewport.height,
//           Oberkante = offsetTop), sobald die Tastatur aufgeht - die Schritte legen sich darueber neu, nichts faehrt
//           hoch. iOS-App-Modus (Home-Bildschirm): Viewport ist um die Statusleiste zu kurz und position: fixed wird
//           dort geclippt (der schwarze Streifen) -> Rahmen absolut, html/body/Rahmen = screen.height minus Tastatur.
//           Der Ausgleich per translateY und --vv-bottom entfaellt; der Toast sitzt am unteren Rand des Rahmens.
// v3.15.0 - Drei Regeln aus der NutriScan-App (Flutter, start.dart; Inhaber, 10.10.2026: "mach die Empfehlungen
//           rein"): (1) vor jedem Schrittwechsel geht die Tastatur zu (blur), kein autoFocus mehr - getippt wird,
//           wenn die Person ins Feld tippt; (2) Fehler stehen am Feld (roter Rand, Text darunter), nicht als
//           Toast - der Toast bleibt fuer Hinweise; (3) Passwort-Schritt zeigt die E-Mail mit "Aendern".
// v3.14.0 - EINE Einstiegsseite fuer Anmelden und Konto erstellen (Inhaber, 10.10.2026: "erstmal die gleiche Seite
//           ... wenn die E-Mail nicht bekannt ist, registrieren, wenn bekannt, Passwort"): gleicher Titel, gleicher
//           Text, gleiche Wege - erst die E-Mail entscheidet (check-email). Kein "Willkommen zurueck" mehr.
// v3.13.1 - Beschriftung im Ruhezustand ohne Hintergrund (Inhaber, 10.10.2026: "schwarzer Hintergrund im Form"):
//           bg-transparent setzte nur die Farbe zurueck, der Verlauf blieb - jetzt background: transparent.
// v3.13.0 - Felder mit schwebender Beschriftung (Inhaber, 10.10.2026, Vorbild-Screenshot): "E-Mail*" steht im
//           Feld, beim Fokus oder mit Inhalt wandert sie klein auf den oberen Rand; mit Inhalt erscheint rechts
//           ein X zum Leeren. Reines CSS (placeholder-shown), funktioniert auch bei Autofill. Passwortfelder
//           behalten das Auge.
// v3.12.0 - Stapel wie die MyEST-Unterseiten (Inhaber, 10.10.2026: "wenn ich weiter tippe, dann kommt das
//           naechste Fenster von rechts nach links rein. Ganz normal. Ohne viel Tamtam"): jeder Schritt ist eine
//           eigene Ebene ueber der vorigen (StepLayer). Vorwaerts schiebt die neue Ebene von rechts drueber, die
//           alte bleibt liegen; Zurueck schiebt die obere nach rechts weg und gibt die darunter frei - exakt
//           PortalSubPage (PUSH 320 ms ease-out, POP 280 ms ease-in). Kein Geist, keine Gegenbewegung mehr.
// v3.11.1 - Schrittwechsel wie iOS (Inhaber, 10.10.2026, "Passwort vergessen" wirkte seltsam): der alte Schritt
//           rutscht mit hinaus (vorwaerts nach links und dunkler, zurueck nach rechts), der neue kommt herein -
//           beide im selben Bild. "Passwort vergessen" ohne Fokus, die Tastatur springt nicht in den Wechsel.
// v3.11.0 - Uebergaenge wie die MyEST-Unterseiten (Inhaber, 10.10.2026: "Nimm doch einfach diese Funktion der
//           Unterseiten"): Seite schiebt per WAAPI von rechts herein (320 ms, ease-out-cubic) und beim Zurueck
//           nach rechts hinaus (280 ms, ease-in-cubic) - dieselben Werte wie PortalSubPage in overlayKit.tsx;
//           jeder Schritt schiebt ebenso von rechts, Zurueck von links. Seite wieder deckend schwarz. Auf der
//           Einstiegsseite (E-Mail oder einer der anderen Wege) keine Tastatur - erst waehlen, dann tippen.
// v3.10.0 - Toast unten, nie dauerhaft (Inhaber, 10.10.2026: "Toasts bitte immer unten und niemals dauerhaft,
//           sondern zwei, drei Sekunden"): Hinweis UND Fehler blenden nach 3 s aus, sitzen am unteren Rand des
//           sichtbaren Ausschnitts (ueber der Tastatur). Seite faehrt von rechts herein (Index.css). Schlaegt
//           check-email fehl (Netz, 500, 429), geht es trotzdem zum Passwort - die Pruefung ist Komfort, kein
//           Tor; der Fehlertext nennt den HTTP-Status, wenn der Server keinen Grund mitschickt.
// v3.9.0 - Hinweis und Fehler als Einblendung oben (unter Pfeil und "?"), nicht mehr als Kasten unter dem
//          Inhalt (Inhaber, 10.10.2026: "Alles muss sichtbar sein" - der Kasten rutschte unter den Rand).
//          Hinweis verschwindet nach 3,5 s, Fehler bleibt bis zum Antippen oder zur naechsten Aktion.
// v3.8.0 - Die Seite kommt von links herein (Inhaber, 10.10.2026: "von links nach rechts, ganz einfach") und ist
//          durchscheinend mit Weichzeichner - dahinter bleibt die Startseite mit dem treibenden Bild sichtbar.
//          Der iOS-Ausgleich (translateY) liegt jetzt auf dem Inhalt, der Rahmen traegt die Einblendung.
// v3.7.0 - Tastatur ging nicht mehr auf (Inhaber, 10.10.2026): seit v3.6.0 wechselt der Schritt erst nach der
//          Server-Antwort, also ausserhalb der Tipp-Geste - iOS fokussiert dann ohne Tastatur, und ein Tipp auf
//          das schon fokussierte Feld holt sie nicht nach. Jetzt: nach einem asynchronen Wechsel kein autoFocus
//          (der Tipp der Person oeffnet die Tastatur), dazu Sicherheitsnetz: Tipp auf ein fokussiertes Feld
//          ohne Tastatur macht blur+focus in der Geste.
// v3.6.0 - EIN Pfad (Inhaber, 10.10.2026, wie Revolut): nach der E-Mail entscheidet check-email - Konto da ->
//          Passwort, kein Konto -> Firma; gilt fuer "Anmelden" und "Konto erstellen" gleichermassen.
// v3.5.1 - Schritt E-Mail pruefte vorab, ob es zu der Adresse schon ein Konto gibt (GET /tenants/check-email):
//          Hinweis + Weg zur Anmeldung, kein Weiter zur Firma (Inhaber, 10.10.2026).
// v3.5.0 - Konto erstellen im selben Stil, Schritt fuer Schritt (Inhaber, 10.10.2026: "Mach diese Stelle
//          genauso in diesem Style wie die Anmeldung ... Nacheinander geht auch"): E-Mail -> Firma + Adresse
//          (Live-Pruefung) -> Name -> Passwort + AGB -> Bestaetigungsmail. Loest die Seite /signup ab (L-6).
// v3.4.2 - Login-Fehler des System-Backends uebersetzt ("Account is disabled", falsches Passwort).
// v3.4.1 - Zittern behoben: kein scrollTo mehr gegen die iOS-Verschiebung, Ausgleich je Bild gebuendelt
//          (requestAnimationFrame); Zurueck aus "Passwort vergessen" fuehrt dorthin, woher man kam.
// v3.4.0 - Auge an/aus in jedem Passwortfeld (Inhaber, 10.10.2026); Safaris gelbe Autofill-Faerbung
//          ueberschrieben (Index.css), das Feld bleibt dunkel.
// v3.3.0 - Der Rahmen laeuft der iOS-Verschiebung des sichtbaren Ausschnitts entgegen (translateY =
//          visualViewport.offsetTop) - der Kopf bleibt optisch stehen, wenn die Tastatur kommt.
// v3.2.0 - Seite waehrend des Ablaufs unbeweglich (html.auth-lock, von Anfang an statt beim Fokus);
//          aeusserer Rahmen overflow-hidden, nur der Inhalt scrollt, wenn er je zu hoch ist.
// v3.1.3 - Wieder volle Hoehe (schwarz auch hinter der Tastatur); das Festhalten macht useKeyboardViewportLock
//          beim Fokus, nicht mehr ueber eine gekuerzte Seite (darunter schimmerte die Startseite durch).
// v3.1.2 - Hoehe folgte dem sichtbaren Ausschnitt (zurueckgenommen).
// v3.1.1 - Passt in den Viewport eines normalen iPhones (Inhaber, 10.10.2026, Screenshot):
//          engere Abstaende wie im Vorbild, der Link "Noch kein Konto?" unter den
//          vier Wegen ist weg - "Konto erstellen" steht auf der Startseite.
// v3.1.0 - Vorbereitung (Inhaber, 10.10.2026: "Ich mach Google, Apple und
//          Passkey auch rein ... Warum nicht auch Telefonnummer?"): unter "oder"
//          stehen Telefonnummer, Passkey, Google, Apple - antippen sagt "Bald
//          verfuegbar". Bewusst gegen "Schloss oder gar nicht", Entscheidung
//          des Inhabers; die Wege dahinter: docs/website-login-concept.md L-5/L-9.
// v3.0.0 - Vollbild statt Fenster, nach dem Vorbild Revolut (Inhaber, 10.10.2026:
//          "mache das so wie bei Revolut"): Pfeil zurueck oben links, "?" oben
//          rechts, grosse Ueberschrift, ein Feld, "Weiter" erst mit gueltiger
//          Eingabe. Schritte: register (E-Mail -> /signup), signin (E-Mail) ->
//          password, forgot, reset, invite, Zielauswahl. Dunkel durchgehend.
//          Google/Apple/Passkey kommen unter "oder", sobald es die Zugangsdaten
//          gibt (docs/website-login-concept.md L-5) - bis dahin kein Knopf.
//          Vorher: LoginModal.tsx (v1.1.0 bis v2.0.0), die Logik ist dieselbe.
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import type { CSSProperties } from 'react';
import axios from 'axios';
import { ArrowLeft, HelpCircle, KeyRound, Phone } from 'lucide-react';
import { buildTargets, goToTarget, LoginTarget, preferFirm, rememberFirm } from '../lib/loginTargets.tsx';
import { useLanguage } from '../lang/index.lang.tsx';
import { canDecline, declineInvitation, lookupInvitation, setUpInvitation, InviteInfo } from '../lib/invitation.ts';
import { forgetEmail, rememberedEmail, rememberEmail } from '../lib/rememberEmail.ts';
import { FloatingField, InlineScreen, markUnlocked, PasscodeSetup, PasswordField } from '@estata/ui';

// register: Konto erstellen (E-Mail, dann /signup). signin: E-Mail -> login: Passwort.
// invite/reset kommen per Link aus der Mail, forgot aus dem Passwort-Schritt.
export type LoginMode = 'register' | 'reg-company' | 'reg-name' | 'reg-password' | 'reg-done' | 'reg-confirm'
  | 'signin' | 'login' | 'invite' | 'forgot' | 'reset' | 'passcode';

interface LoginFlowProps {
  mode: LoginMode;
  // Zurueck zur Startseite (Logo, Konto erstellen / Anmelden).
  onClose: () => void;
  // Wenn gesetzt (>=2 Ziele), beginnt der Ablauf direkt bei der Zielauswahl (lebende Sitzung).
  initialTargets?: LoginTarget[];
  inviteToken?: string;
  resetToken?: string;
  // Link aus der Registrierungs-Mail (?signup=): bestaetigen mit Passwort, dann angemeldet
  signupToken?: string;
  // Konto erstellen: Plan aus /pricing (Standard, wenn nichts gewaehlt) und ggf. vorbelegte Adresse.
  plan?: string;
  initialEmail?: string;
  // KI-App verbinden (OAuthConsent): nach der Anmeldung zur Zustimmung statt in den Bereich
  onSignedIn?: () => void;
  // Link /login?firm=<Kurzname der Firma>: Name der Firma ueber Anmelden und Passwort
  firmName?: string;
}


const PASSWORD_MIN_LENGTH = 8;
const SUPPORT_MAIL = 'info@estata.com';

// Revolut-Optik: dunkle, runde Felder; weisser Pillen-Knopf; blaue Textlinks.
const FIELD = 'w-full h-14 px-5 rounded-2xl bg-[#1c1c1e] text-white text-[17px] placeholder-[#8e8e93] border border-transparent focus:outline-none focus:border-[#3a3a3c] read-only:text-[#8e8e93]';

const PRIMARY = 'w-full h-14 rounded-full bg-white text-black text-[17px] font-semibold disabled:bg-[#3a3a3c] disabled:text-[#8e8e93] transition-colors';
const SECONDARY = 'w-full h-14 rounded-full bg-[#1c1c1e] text-white text-[17px] font-semibold flex items-center justify-center gap-3';
// Textlink mit 44 px Tippflaeche (HIG), ohne das Layout zu verschieben: eine unsichtbare Flaeche (::after) ragt oben
// und unten 9 px ueber den 26 px hohen Text hinaus
const LINK = "relative text-[16px] text-[#4f8cff] text-left after:absolute after:inset-x-0 after:-inset-y-[9px] after:content-['']";
const ROUND = 'w-12 h-12 rounded-full bg-[#1c1c1e] text-white flex items-center justify-center';

// Uebergaenge wie die Unterseiten in MyEST (apps/0002-myest/.../overlayKit.tsx: PUSH_MS, POP_MS, Kurven).
const PUSH_MS = 320;
const POP_MS = 280;
const EASE_OUT_CUBIC = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
const EASE_IN_CUBIC = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

// Nur fuer die Geraeteliste des Bauleiters ('iPhone von Kemal'). Bewusst grob.
function guestDeviceLabel(): string {
  const ua = navigator.userAgent;
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua)) return 'iPad';
  if (/Android/.test(ua)) return 'Android-Gerät';
  return 'Computer';
}

function clientTimezone(): string | undefined {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { return undefined; }
}

// Backend kann 'detail' als String ODER als Object {error, message} schicken.
function errorMessage(err: any, fallback: string): string {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') return detail.message || detail.error || fallback;
  // Antwort ohne Grund (z. B. 502 von nginx, 500 als Text): wenigstens den Status zeigen.
  const status = err?.response?.status;
  return status ? `${fallback} (${status})` : fallback;
}

// Platzhalter wie {email} oder {n} in einem uebersetzten Satz fuellen.
function fill(text: string, values: Record<string, string | number>): string {
  return Object.entries(values).reduce((out, [k, v]) => out.split(`{${k}}`).join(String(v)), text);
}

const isEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());


// Markenzeichen als Pfade - lucide fuehrt keine Firmenlogos.
const GoogleMark = () => (
  <svg viewBox="0 0 48 48" width="20" height="20" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);
const AppleMark = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
  </svg>
);

// Eine Ebene des Stapels: liegt ueber der vorigen und schiebt beim Anlegen von rechts herein (wie PortalSubPage).
// Scrollt selbst, wenn ihr Inhalt je zu hoch ist. Die erste Ebene kommt mit dem Rahmen, nicht noch einmal.
function StepLayer({ initial, active, register, children }: {
  initial: boolean; active: boolean; register: (el: HTMLDivElement | null) => void; children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  // Verdeckte Ebenen (die Schritte darunter) sind fuer VoiceOver und Tastatur stumm - wie die Seiten unter einer
  // iOS-Unterseite. inert als DOM-Eigenschaft (React 18 kennt das Attribut noch nicht).
  useEffect(() => {
    const el = ref.current as (HTMLDivElement & { inert?: boolean }) | null;
    if (el) el.inert = !active;
  }, [active]);
  useLayoutEffect(() => {
    const el = ref.current;
    register(el);
    if (!el || initial || reducedMotion()) return () => register(null);
    const a = el.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
      { duration: PUSH_MS, easing: EASE_OUT_CUBIC, fill: 'both' });
    let cancelled = false;
    a.finished.then(() => { if (!cancelled) a.cancel(); }, () => {});
    return () => { cancelled = true; a.cancel(); register(null); };
  }, []);
  return (
    <div ref={ref} aria-hidden={active ? undefined : true}
         className="absolute inset-0 bg-black overflow-y-auto overflow-x-hidden overscroll-contain">
      <div className="min-h-full max-w-md mx-auto px-5 pt-[calc(12px+env(safe-area-inset-top))] pb-[calc(16px+env(safe-area-inset-bottom))]">
        {children}
      </div>
    </div>
  );
}

// Bestaetigungsblatt: leicht durchsichtig mit Unschaerfe dahinter (Inhaber, 12.10.2026) - wie ein iOS-Blatt.
const CONFIRM_SHEET: CSSProperties = {
  backgroundColor: 'rgba(28, 28, 30, 0.5)',
  backdropFilter: 'blur(20px) saturate(160%)',
  WebkitBackdropFilter: 'blur(20px) saturate(160%)',
};

/** Schriftgroesse, mit der die Adresse in EINER Zeile ins Blatt passt (Inhaber: "kein Umbruch"): hoechstens 24 px,
 *  sonst so klein, dass die Zeichen in die Innenbreite passen (Blatt min(100vw - 40px, 448px), Innenrand 2 x 24 px;
 *  0.62 em je Zeichen = Breite fetter Zeichen mit Reserve). Ganz lange Adressen enden mit "...". */
export function fitEmailFontSize(email: string): string {
  const chars = Math.max(1, email.length);
  return `min(24px, calc((min(100vw - 40px, 448px) - 48px) / ${(chars * 0.62).toFixed(2)}))`;
}

function LoginFlow({ mode: initialMode, onClose, initialTargets, inviteToken, resetToken, signupToken, plan = 'standard',
                     initialEmail = '', onSignedIn, firmName }: LoginFlowProps) {
  const { t, currentLanguage } = useLanguage();
  // Der Stapel der Schritte: der oberste ist sichtbar und bedienbar, die darunter bleiben liegen (wie die
  // Unterseiten in MyEST). Vorwaerts = oben drauflegen, Zurueck = oberste Ebene abraeumen.
  const [stack, setStack] = useState<LoginMode[]>([initialMode]);
  const mode = stack[stack.length - 1];
  // Ueber welchen Knopf die Person kam (Anmelden oder Konto erstellen) - dorthin fuehrt Zurueck vom
  // Passwort- bzw. Firmen-Schritt; der Pfad dahinter ist derselbe.
  const entry: LoginMode = initialMode === 'register' ? 'register' : 'signin';
  // C-5: ohne vorgegebene Adresse (Einladung, ?email=) steht beim Anmelden die zuletzt benutzte da
  const [remembered, setRemembered] = useState(() => (initialEmail || initialMode !== 'signin' ? '' : rememberedEmail()));
  const [email, setEmail] = useState(initialEmail || remembered);
  // C-2: Bestaetigungsblatt ueber dem E-Mail-Schritt, wenn die Adresse ein Konto hat
  const [confirming, setConfirming] = useState(false);
  // Das Blatt hat beim Oeffnen den Fokus auf "Bestaetigen" (VoiceOver liest Adresse und Frage, Enter bestaetigt)
  const confirmButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => { if (confirming) confirmButtonRef.current?.focus({ preventScroll: true }); }, [confirming]);
  // C-3: Ziele nach der Anmeldung, bis der Passcode fuer dieses Geraet festgelegt ist
  const [afterPasscode, setAfterPasscode] = useState<LoginTarget[] | null>(null);
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [targets, setTargets] = useState<LoginTarget[]>(initialTargets || []);
  const [switching, setSwitching] = useState(false);
  const [invite, setInvite] = useState<InviteInfo | null>(null);
  // Ein toter Link (abgelaufen, ersetzt, verbraucht) zeigt nur noch diesen Satz.
  const [deadLink, setDeadLink] = useState('');
  // E-5: gewaehlte Firma (nur bei mehreren); E-6: Ablehnen mit Rueckfrage
  const [orgId, setOrgId] = useState<string | null>(null);
  const [confirmDecline, setConfirmDecline] = useState(false);
  const [declined, setDeclined] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);
  // "Bald verfuegbar" fuer die vorbereiteten Wege (Telefon, Passkey, Google, Apple).
  const [notice, setNotice] = useState('');
  // Auge an/aus: Passwort im Klartext zeigen (Inhaber, 10.10.2026) - ein Schalter fuer alle Passwortfelder.
  const [showPassword, setShowPassword] = useState(false);
  // Darf das erste Feld des naechsten Schritts von selbst den Fokus bekommen? Nur, wenn der Wechsel in der
  // Tipp-Geste passiert (Formular abgeschickt -> sofort naechster Schritt). Nach einer Server-Antwort nicht:
  // iOS oeffnet fuer programmatischen Fokus ausserhalb der Geste keine Tastatur - und ein Tipp auf das dann
  // schon fokussierte Feld holt sie nicht nach (Inhaber, 10.10.2026: "laesst sich die Tastatur gar nicht mehr").
  const [focusNext, setFocusNext] = useState(false);
  // Toast: Hinweise blenden nach 3 s von selbst aus, nie dauerhaft (Inhaber, 10.10.2026). Fehler stehen am Feld
  // und verschwinden beim Tippen; nur auf Schritten ohne Feld laufen sie ueber den Toast.
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => setNotice(''), 3000);
    return () => window.clearTimeout(timer);
  }, [notice]);
  // Tippen loescht den Fehler am Feld.
  const typed = (set: (v: string) => void) => (v: string) => { set(v); if (error) setError(''); };
  // Tastatur zu, bevor ein Schritt wechselt (wie FocusScope.unfocus() in der NutriScan-App).
  const closeKeyboard = () => { (document.activeElement as HTMLElement | null)?.blur?.(); };

  // Sicherheitsnetz fuer genau diesen Fall: Feld ist fokussiert, Tastatur zu, Person tippt es an -> in der
  // Geste blur + focus, das oeffnet die Tastatur. Mit offener Tastatur oder am Desktop passiert nichts.
  const retapFocus = (e: React.MouseEvent<HTMLInputElement>) => {
    const el = e.currentTarget;
    if (document.activeElement !== el) return;
    if (!window.matchMedia('(pointer: coarse)').matches) return;
    const vv = window.visualViewport;
    if (vv && vv.height < window.innerHeight * 0.8) return;
    el.blur();
    el.focus();
  };
  // Konto erstellen (L-6): Schritt fuer Schritt wie die Anmeldung - Firma, Name, Passwort, fertig.
  const [company, setCompany] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [agb, setAgb] = useState(false);
  // Link aus der Registrierungs-Mail: was bestaetigt wird (Firma)
  const [signup, setSignup] = useState<{ company_name: string } | null>(null);


  // EIN Pfad fuer Anmelden und Konto erstellen (Inhaber, 10.10.2026, wie bei Revolut): nach der E-Mail
  // entscheidet der Server - gibt es das Konto, kommt das Passwort; gibt es keins, kommt die Firma.
  const handleEmailStep = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isEmail(email)) return;
    setError('');
    // Konto erstellen fragt NICHT, ob es die Adresse gibt (Inhaber 21.10.2026) - fuer jede Adresse dieselben
    // Schritte; ob es schon ein Konto gibt, steht nur in der Mail.
    if (stack[0] === 'register') { switchMode('reg-password', false, true); return; }
    setLoading(true);
    try {
      const res = await axios.get('/system/api/v1/tenants/check-email', { params: { email: email.trim() } });
      setLoading(false);
      // Bekannt: erst bestaetigen (Bestaetigungsblatt), dann Passwort. Unbekannt: Konto erstellen.
      if (res.data?.exists) { closeKeyboard(); setConfirming(true); } else switchMode('reg-password', false, true);
    } catch (err: any) {
      // Die Pruefung ist Komfort, kein Tor: faellt sie aus (Netz, 500, Bremse), geht es zum Passwort weiter -
      // dort entscheidet der Login selbst. Nur ein echtes "Zu viele Anfragen" bleibt stehen.
      setLoading(false);
      if (err?.response?.status === 429) { setError(errorMessage(err, t('login.errGeneric'))); return; }
      switchMode('login', false);
    }
  };

  // Antwort des Servers -> Satz in der Sprache der Person (Passwort-Regel, Adresse, Bestaetigung).
  const serverMessage = (err: any, fallback: string): string => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 429) return t('login.errTooMany');
    const code = detail && typeof detail === 'object' && !Array.isArray(detail) ? (detail.code || detail.error) : '';
    if (code === 'too_short' || code === 'password_too_short') return fill(t('login.errTooShort'), { n: PASSWORD_MIN_LENGTH });
    if (code === 'too_common' || code === 'password_too_common') return t('login.pwTooCommon');
    if (code === 'too_personal' || code === 'password_too_personal') return t('login.pwTooPersonal');
    if (code === 'too_long' || code === 'password_too_long') return t('login.pwTooLong');
    if (code === 'wrong_password') return t('login.errWrongPassword');
    return errorMessage(err, fallback);
  };

  // Zum Schritt mit dem Feld zurueck und den Grund dort zeigen (nach der Abraeum-Animation).
  const backToStep = (step: LoginMode, message: string) => {
    const idx = stack.lastIndexOf(step);
    if (idx < 0 || idx === stack.length - 1) { setError(message); return; }
    popTo(idx + 1, () => setError(message));
  };

  const submitRegistration = async () => {
    await axios.post('/system/api/v1/tenants/register', {
      company_name: company.trim(),
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email: email.trim(),
      password,
      plan,
    });
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!agb) return;
    setLoading(true);
    try {
      await submitRegistration();
      switchMode('reg-done', false, true);
    } catch (err: any) {
      const detail = err?.response?.data?.detail;
      const field: string = Array.isArray(detail) ? String(detail[0]?.loc?.[detail[0].loc.length - 1] || '')
        : (detail && typeof detail === 'object' ? detail.field || '' : '');
      const message = Array.isArray(detail) ? t('login.errFields') : serverMessage(err, t('login.errGeneric'));
      if (field === 'password') backToStep('reg-password', message);
      else if (field === 'first_name' || field === 'last_name') backToStep('reg-name', message);
      else if (field === 'email') backToStep(stack[0], message);
      else setError(message);
    }
    setLoading(false);
  };

  // "Keine Mail bekommen?" - dieselbe Anfrage noch einmal (der neue Link ersetzt den alten; gebremst).
  const resendRegistration = async () => {
    setLoading(true);
    try {
      await submitRegistration();
      setNotice(t('login.resent'));
    } catch (err: any) {
      setError(serverMessage(err, t('login.errGeneric')));
    }
    setLoading(false);
  };

  // Link aus der Mail (?signup=): was bestaetigt wird - sonst toter Link.
  useEffect(() => {
    if (!signupToken) return;
    let cancelled = false;
    axios.get('/system/api/v1/tenants/register/pending', { params: { token: signupToken } })
      .then((res) => {
        if (cancelled) return;
        setSignup({ company_name: res.data?.company_name || '' });
        setEmail(res.data?.email || '');
      })
      .catch((err) => { if (!cancelled) setDeadLink(serverMessage(err, t('login.errDead'))); });
    return () => { cancelled = true; };
  }, [signupToken]);

  // Bestaetigen: neue Adresse mit dem gewaehlten Passwort, bekannte mit dem bisherigen - danach angemeldet.
  const handleConfirmSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!signupToken || !password) return;
    setError('');
    setLoading(true);
    let mail = email;
    try {
      const res = await axios.post('/system/api/v1/tenants/register/confirm', { token: signupToken, password });
      mail = res.data?.email || email;
      rememberFirm(res.data?.slug);
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 410) setDeadLink(serverMessage(err, t('login.errDead')));
      else setError(serverMessage(err, t('login.errGeneric')));
      setLoading(false);
      return;
    }
    try {
      await signInAndGo(mail, password);
    } catch {
      // Angelegt ist es - dann eben von Hand anmelden.
      setStack(['signin']);
      setEmail(mail);
      setPassword('');
      setLoading(false);
    }
  };

  // Solange der Ablauf offen ist, ist die Seite unbeweglich (Index.css html.auth-lock) - nicht erst beim
  // Fokus: das war fuer iOS zu spaet, die Seite ruckte beim Oeffnen der Tastatur hoch und wieder runter.
  useEffect(() => {
    document.documentElement.classList.add('auth-lock');
    window.scrollTo(0, 0);
    return () => { document.documentElement.classList.remove('auth-lock'); };
  }, []);

  // Kein Ausgleich fuer die Tastatur mehr (Inhaber, 10.10.2026): das kommt mit der Capacitor-Huelle.
  const shellRef = useRef<HTMLDivElement>(null);

  // Seite schiebt von rechts herein (wie PortalSubPage), beim Schliessen nach rechts hinaus.
  const closingRef = useRef(false);
  useLayoutEffect(() => {
    const el = shellRef.current;
    if (!el || reducedMotion()) return;
    const a = el.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
      { duration: PUSH_MS, easing: EASE_OUT_CUBIC, fill: 'both' });
    let cancelled = false;
    a.finished.then(() => { if (!cancelled) a.cancel(); }, () => {});
    return () => { cancelled = true; a.cancel(); };
  }, []);
  const requestClose = () => {
    if (closingRef.current) return;
    closingRef.current = true;
    closeKeyboard();
    const el = shellRef.current;
    if (!el || reducedMotion()) { onClose(); return; }
    const a = el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }],
      { duration: POP_MS, easing: EASE_IN_CUBIC, fill: 'forwards' });
    a.finished.then(() => onClose(), () => onClose());
  };

  // Ebenen-Knoten je Schluessel (fuer die Abraeum-Animation) und Sperre gegen doppeltes Zurueck.
  const layerNodes = useRef<Record<string, HTMLDivElement | null>>({});
  // Die allererste Ebene kommt mit der Seite herein (Rahmen-Animation), nicht noch einmal fuer sich.
  const firstLayerKey = useRef(`0-${initialMode}`);
  const popping = useRef(false);
  const layerKey = (i: number, m: LoginMode) => `${i}-${m}`;
  // Oberste Ebene nach rechts hinausschieben, dann den Stapel auf n Ebenen kuerzen.
  const popTo = (n: number, after?: () => void) => {
    if (popping.current) return;
    closeKeyboard();
    const topKey = layerKey(stack.length - 1, stack[stack.length - 1]);
    const el = layerNodes.current[topKey];
    if (!el || reducedMotion()) { setStack((prev) => prev.slice(0, n)); after?.(); return; }
    popping.current = true;
    el.style.pointerEvents = 'none';
    const a = el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }],
      { duration: POP_MS, easing: EASE_IN_CUBIC, fill: 'forwards' });
    const done = () => { popping.current = false; setStack((prev) => prev.slice(0, n)); after?.(); };
    a.finished.then(done, done);
  };

  useEffect(() => {
    if (!inviteToken) return;
    let cancelled = false;
    lookupInvitation(inviteToken)
      .then((info) => {
        if (cancelled) return;
        setInvite(info);
        setEmail(info.email || '');
      })
      .catch(async (err) => {
        if (cancelled) return;
        // Verbrauchter Link, aber angemeldet (Cookie): die Person ist drin - kein "Link verbraucht".
        try {
          const check = await axios.get('/system/api/v1/auth/check', { withCredentials: true });
          if (check.data?.authenticated) {
            const found = preferFirm(buildTargets(check.data.user));
            if (found.length <= 1) { await goToTarget(found[0] || { kind: 'tenant', label: '' }); return; }
            setTargets(found);
            return;
          }
        } catch { /* nicht angemeldet - dann der Satz unten */ }
        if (cancelled) return;
        setDeadLink(errorMessage(err, t('login.errDead')));
      });
    return () => { cancelled = true; };
  }, [inviteToken]);

  const selectTarget = async (target: LoginTarget) => {
    setSwitching(true);
    await goToTarget(target);
  };

  // Anmelden am System und in den eigenen Bereich - der gemeinsame Schluss von Anmeldung, Einladung und
  // neuem Passwort. Die Ziel-Liste kommt direkt aus der Login-Antwort (kein /auth/check-Polling).
  const signInAndGo = async (mail: string, pw: string) => {
    const login = await axios.post('/system/api/v1/auth/login', { username: mail, password: pw },
      { withCredentials: true });
    rememberEmail(mail);
    if (onSignedIn) { setLoading(false); onSignedIn(); return; }
    const user = login.data?.user;
    const found = user ? preferFirm(buildTargets(user)) : [];
    // C-3: hat dieses Geraet noch keinen Passcode, wird er jetzt festgelegt - das Passwort ist gerade frisch getippt.
    let hasPasscode = true;
    try {
      const check = await axios.get('/system/api/v1/auth/check', { withCredentials: true });
      hasPasscode = check.data?.passcode?.set !== false;
    } catch { /* Pruefung ist Komfort - ohne Antwort fragt MyEST beim Oeffnen */ }
    if (!hasPasscode) {
      setAfterPasscode(found);
      setStack((prev) => [...prev, 'passcode']);
      setLoading(false);
      return;
    }
    await continueTo(found);
  };

  // Nach Passwort (und ggf. Passcode festlegen): die App ist entsperrt, weiter in den Bereich.
  const continueTo = async (found: LoginTarget[]) => {
    markUnlocked();
    if (found.length <= 1) {
      await selectTarget(found[0] || { kind: 'tenant', label: '' });
    } else {
      setTargets(found);
      setLoading(false);
    }
  };

  // Die bekannten englischen Antworten des System-Logins in die Sprache der Person uebersetzen.
  const loginError = (err: any): string => {
    const detail = err?.response?.data?.detail;
    if (detail === 'Account is disabled') return t('login.errDisabled');
    // Zu viele Versuche (429) oder deshalb voruebergehend gesperrt (403 account_locked): nie den englischen Servertext
    if (err?.response?.status === 429) return t('login.errTooMany');
    if (detail && typeof detail === 'object' && detail.error === 'account_locked') return t('login.errTooMany');
    if (typeof detail === 'string' && /incorrect email or password/i.test(detail)) return t('login.errLogin');
    return errorMessage(err, t('login.errLogin'));
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInAndGo(email, password);
    } catch (err: any) {
      setError(loginError(err));
      setLoading(false);
    }
  };

  const checkNewPassword = (minLength: number): string => {
    if (password.length < minLength) return fill(t('login.errTooShort'), { n: minLength });
    if (password !== passwordRepeat) return t('login.errMismatch');
    return '';
  };

  const handleInvite = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!invite || !inviteToken) return;
    setError('');
    const askName = invite.multi_use && !invite.person_name;
    if (askName && displayName.trim().length < 2) { setError(t('login.errName')); return; }
    if ((invite.companies?.length || 0) > 1 && !orgId) { setError(t('login.errCompany')); return; }
    if (!invite.has_account) {
      const problem = checkNewPassword(invite.password_min_length || PASSWORD_MIN_LENGTH);
      if (problem) { setError(problem); return; }
    }
    setLoading(true);
    try {
      await setUpInvitation(inviteToken, invite, {
        password,
        display_name: askName ? displayName.trim() : undefined,
        org_id: orgId || undefined,
        device_label: guestDeviceLabel(),
        client_timezone: clientTimezone(),
        language: currentLanguage,
      });
    } catch (err: any) {
      const status = err?.response?.status;
      const msg = errorMessage(err, t('login.errSetup'));
      if (status === 404 || status === 410) setDeadLink(msg); else setError(msg);
      setLoading(false);
      return;
    }
    try {
      // Konto statt Gast (K-2): mit dem frischen Passwort gleich in den eigenen Bereich.
      await signInAndGo(invite.email, password);
    } catch (err: any) {
      setError(errorMessage(err, t('login.setupLoginFailed')));
      setStack((prev) => [...prev, 'login']);
      setLoading(false);
    }
  };

  // E-6: "Die Einladung ist nicht fuer mich" - zurueckziehen, wer eingeladen hat, bekommt eine Nachricht
  const handleDecline = async () => {
    if (!inviteToken) return;
    setError('');
    setLoading(true);
    try {
      await declineInvitation(inviteToken);
      setDeclined(true);
    } catch (err: any) {
      setError(errorMessage(err, t('login.errGeneric')));
    }
    setConfirmDecline(false);
    setLoading(false);
  };

  const handleForgot = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post('/system/api/v1/auth/password/forgot', { email });
      setForgotSent(true);
    } catch (err: any) {
      setError(errorMessage(err, t('login.errGeneric')));
    }
    setLoading(false);
  };

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!resetToken) return;
    setError('');
    const problem = checkNewPassword(PASSWORD_MIN_LENGTH);
    if (problem) { setError(problem); return; }
    setLoading(true);
    let mail = '';
    try {
      const res = await axios.post('/system/api/v1/auth/password/reset', { token: resetToken, password });
      mail = res.data?.email || '';
    } catch (err: any) {
      const status = err?.response?.status;
      const msg = errorMessage(err, t('login.errReset'));
      if (status === 404 || status === 410) setDeadLink(msg); else setError(msg);
      setLoading(false);
      return;
    }
    try {
      await signInAndGo(mail, password);
    } catch {
      // Gesetzt ist es - dann eben von Hand anmelden.
      setStack(['signin']);
      setEmail(mail);
      setPassword('');
      setPasswordRepeat('');
      setLoading(false);
    }
  };

  // Naechster Schritt: neue Ebene oben drauf (schiebt von rechts herein). Die Einstiegsseiten (Anmelden /
  // Konto erstellen) sind immer die unterste Ebene: liegt sie schon unten, wird bis dorthin abgeraeumt.
  // keepPassword: Konto erstellen traegt das Passwort aus Schritt 2 bis zum Absenden (und fuer "erneut senden") mit.
  const switchMode = (next: LoginMode, _focus = false, keepPassword = false) => {
    closeKeyboard();
    setFocusNext(false);
    if (next === 'signin' || next === 'register') {
      if (stack[0] === next && stack.length > 1) popTo(1);
      else setStack([next]);
    } else {
      setStack((prev) => [...prev, next]);
    }
    setError('');
    setNotice('');
    setDeadLink('');
    setForgotSent(false);
    if (!keepPassword) {
      setPassword('');
      setPasswordRepeat('');
    }
  };

  // Der Pfeil geht einen Schritt zurueck; vom ersten Schritt aus zur Startseite.
  const back = () => {
    if (stack.length > 1) { setFocusNext(false); setError(''); setNotice(''); popTo(stack.length - 1); return; }
    requestClose();
  };

  const header = (title: string, sub?: React.ReactNode, firm?: string) => (
    <>
      <div className="flex items-center justify-between">
        <button type="button" onClick={back} className={ROUND} aria-label={t('login.back')}>
          <ArrowLeft size={22} />
        </button>
        <a href={`mailto:${SUPPORT_MAIL}`} className={ROUND} aria-label={t('login.help')}>
          <HelpCircle size={22} />
        </a>
      </div>
      {firm && <p className="mt-5 text-[15px] font-semibold text-[#8e8e93] truncate" data-firm>{firm}</p>}
      <h1 className={`${firm ? 'mt-1' : 'mt-5'} text-[34px] leading-[1.1] font-bold text-white`}>{title}</h1>
      {sub && <p className="mt-1.5 text-[17px] leading-snug text-[#8e8e93]">{sub}</p>}
    </>
  );

  const emailField = (readOnly = false, autoFocus = focusNext) => (
    <FloatingField type="email" label={t('login.email')} value={email} onChange={typed(setEmail)} onClick={retapFocus}
                   readOnly={readOnly} autoComplete={readOnly ? 'username' : 'email'} autoFocus={autoFocus} enterKeyHint="next"
                   error={readOnly ? undefined : fieldError} required />
  );

  // Passwortfeld mit Auge (zeigen/verbergen) und X - das gemeinsame Feld aus @estata/ui; ein Auge fuer alle Felder.
  const passwordField = (value: string, setValue: (v: string) => void, placeholder: string,
                         autoComplete: 'current-password' | 'new-password', autoFocus = false, minLength?: number,
                         showError = true) => (
    <PasswordField label={placeholder} value={value} onChange={typed(setValue)} onClick={retapFocus}
                   autoComplete={autoComplete} minLength={minLength} autoFocus={autoFocus && focusNext} required
                   enterKeyHint={autoComplete === 'current-password' ? 'go' : 'next'}
                   error={showError ? fieldError : undefined} shown={showPassword} onShownChange={setShowPassword} />
  );

  const passwordPair = (minLength: number) => (
    <>
      {passwordField(password, setPassword, `${t('login.password')} (${fill(t('login.minChars'), { n: minLength })})`,
        'new-password', true, minLength)}
      {passwordField(passwordRepeat, setPasswordRepeat, t('login.passwordRepeat'), 'new-password', false, minLength, false)}
    </>
  );

  // Die weiteren Wege unter "oder" - vorbereitet, noch ohne Funktion (L-5/L-9).
  const soon = () => setNotice(t('login.comingSoon'));
  const otherWays = (
    <>
      <div className="flex items-center gap-4 pt-1">
        <div className="flex-1 h-px bg-[#3a3a3c]" />
        <span className="text-[15px] text-[#8e8e93]">{t('login.or')}</span>
        <div className="flex-1 h-px bg-[#3a3a3c]" />
      </div>
      <button type="button" className={SECONDARY} onClick={soon}><Phone size={20} /><span>{t('login.continuePhone')}</span></button>
      <button type="button" className={SECONDARY} onClick={soon}><KeyRound size={20} /><span>{t('login.continuePasskey')}</span></button>
      <button type="button" className={SECONDARY} onClick={soon}><GoogleMark /><span>{t('login.continueGoogle')}</span></button>
      <button type="button" className={SECONDARY} onClick={soon}><AppleMark /><span>{t('login.continueApple')}</span></button>
    </>
  );

  // Auf Schritten mit Feld steht der Fehler am ersten Feld; ohne Feld (Zielauswahl, toter Link, Bestaetigung,
  // Link verschickt) bleibt der Toast.
  const errorInline = targets.length === 0 && !deadLink && !forgotSent && mode !== 'reg-done';
  const fieldError = errorInline ? error || undefined : undefined;
  const stepBody = (m: LoginMode, isTop: boolean): React.ReactNode => {
  let body: React.ReactNode;
  if (isTop && targets.length > 0) {
    body = (
      <>
        {header(t('login.chooseTarget'))}
        <div className="mt-7 space-y-3">
          {targets.map((target) => (
            <button key={target.kind === 'system' ? 'system' : target.tenantId} type="button" disabled={switching}
                    onClick={() => selectTarget(target)} className={`${SECONDARY} justify-between px-5`}>
              <span>{target.label}</span>
              <span className="text-[13px] text-[#8e8e93] font-normal">
                {target.kind === 'system' ? t('login.system') : t('login.tenant')}
              </span>
            </button>
          ))}
          {switching && <p className="text-center text-[15px] text-[#8e8e93]">{t('login.redirecting')}</p>}
        </div>
      </>
    );
  } else if (isTop && deadLink) {
    body = (
      <>
        {header(m === 'reset' ? t('login.resetTitle') : m === 'reg-confirm' ? t('login.signupTitle') : t('login.setupTitle'),
                deadLink)}
        <div className="mt-7 space-y-4">
          {m === 'reset' ? (
            <button type="button" className={PRIMARY} onClick={() => switchMode('forgot', false)}>{t('login.newLink')}</button>
          ) : m === 'reg-confirm' ? (
            <button type="button" className={PRIMARY} onClick={() => switchMode('register')}>{t('login.createAccount')}</button>
          ) : (
            <p className="text-[15px] text-[#8e8e93]">{t('login.deadInvite')}</p>
          )}
          <button type="button" className={SECONDARY} onClick={() => switchMode('signin')}>{t('login.toLogin')}</button>
        </div>
      </>
    );
  } else if (m === 'passcode') {
    // C-3: vier Ziffern fuer dieses Geraet, zweimal - danach weiter in den Bereich (entsperrt).
    body = (
      <InlineScreen>
      <PasscodeSetup
        title={t('login.passcodeSetTitle')}
        repeatTitle={t('login.passcodeRepeatTitle')}
        subtitle={t('login.passcodeSetSub')}
        mismatch={t('login.passcodeMismatch')}
        error={error || undefined}
        busy={loading}
        deleteLabel={t('login.passcodeDelete')}
        onSet={async (code) => {
          setError('');
          setLoading(true);
          try {
            await axios.post('/system/api/v1/auth/passcode', { code }, { withCredentials: true });
          } catch (err: any) {
            setLoading(false);
            setError(errorMessage(err, t('login.passcodeSaveFailed')));
            throw err;
          }
          await continueTo(afterPasscode || []);
        }}
      />
      </InlineScreen>
    );
  } else if (m === 'register' || m === 'signin') {
    // Dieselbe Seite fuer beide Knoepfe der Startseite - erst die E-Mail entscheidet, wie es weitergeht.
    const welcomeBack = m === 'signin' && !!remembered && email === remembered;
    body = (
      <form onSubmit={handleEmailStep}>
        {header(welcomeBack ? t('login.confirmTitle') : t('login.entryTitle'),
                welcomeBack ? t('login.confirmSub') : t('login.entrySub'), m === 'signin' ? firmName : undefined)}
        <div className="mt-7 space-y-4">
          {emailField(false, false)}
          {/* Nur "Nicht du?" - "Passwort vergessen?" steht erst beim Passwort (Inhaber 01.11.2026: "hier wird doch
              erstmal die E-Mail-Adresse eingegeben") */}
          {welcomeBack && (
            <div className="flex items-center" data-email-links>
              <button type="button" className={LINK} data-not-you
                      onClick={() => { forgetEmail(); setRemembered(''); setEmail(''); }}>
                {t('login.notYou')}
              </button>
            </div>
          )}
          <button type="submit" disabled={!isEmail(email) || loading} className={PRIMARY}>
            {loading ? t('login.moment') : t('login.next')}
          </button>
          {otherWays}
        </div>
        {isTop && confirming && (
          <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 px-5" data-confirm-email
               onKeyDown={(e) => { if (e.key === 'Escape') { e.preventDefault(); setConfirming(false); } }}>
            <div className="w-full max-w-md rounded-[32px] border border-white/10 px-6 pt-8 pb-6 text-center shadow-2xl"
                 style={CONFIRM_SHEET} role="alertdialog" aria-modal="true"
                 aria-labelledby="confirm-email-address" aria-describedby="confirm-email-question">
              <p id="confirm-email-address" className="font-bold text-white whitespace-nowrap overflow-hidden text-ellipsis"
                 style={{ fontSize: fitEmailFontSize(email.trim()) }}>{email.trim()}</p>
              <p id="confirm-email-question" className="mt-5 text-[16px] leading-snug text-[#8e8e93]">{t('login.confirmQuestion')}</p>
              <div className="mt-7 space-y-3">
                <button type="button" className={PRIMARY} ref={confirmButtonRef}
                        onClick={() => { setConfirming(false); switchMode('login', false); }}>
                  {t('login.confirm')}
                </button>
                <button type="button" className="w-full h-14 rounded-full bg-[#3a3a3c] text-white text-[17px] font-semibold"
                        onClick={() => setConfirming(false)}>
                  {t('login.back')}
                </button>
              </div>
            </div>
          </div>
        )}
      </form>
    );
  } else if (m === 'reg-password') {
    // Schritt 2 von 4: das Passwort. Ob es taugt (Laenge hier, Sperrliste/Name beim Absenden), steht am Feld.
    body = (
      <form onSubmit={(e) => {
        e.preventDefault();
        if (password.length < PASSWORD_MIN_LENGTH) { setError(fill(t('login.errTooShort'), { n: PASSWORD_MIN_LENGTH })); return; }
        switchMode('reg-name', false, true);
      }}>
        {header(t('login.regPasswordTitle'), t('login.regPasswordSub'))}
        {/* Die Adresse bleibt im Formular (Passwort-Manager speichert Adresse + neues Passwort), aber unsichtbar. */}
        <input type="email" value={email} readOnly autoComplete="username" className="hidden" />
        <div className="mt-7 space-y-4">
          {passwordField(password, setPassword, `${t('login.password')} (${fill(t('login.minChars'), { n: PASSWORD_MIN_LENGTH })})`,
            'new-password', true, PASSWORD_MIN_LENGTH)}
          <button type="submit" disabled={password.length < PASSWORD_MIN_LENGTH} className={PRIMARY}>{t('login.next')}</button>
        </div>
      </form>
    );
  } else if (m === 'reg-name') {
    body = (
      <form onSubmit={(e) => { e.preventDefault(); if (firstName.trim() && lastName.trim()) switchMode('reg-company', false, true); }}>
        {header(t('login.regNameTitle'), t('login.regNameSub'))}
        <div className="mt-7 space-y-4">
          <FloatingField label={t('login.firstName')} value={firstName} onChange={typed(setFirstName)} autoComplete="given-name"
                         onClick={retapFocus} autoFocus={focusNext} required error={fieldError} />
          <FloatingField label={t('login.lastName')} value={lastName} onChange={typed(setLastName)} autoComplete="family-name"
                         onClick={retapFocus} required />
          <button type="submit" disabled={!firstName.trim() || !lastName.trim()} className={PRIMARY}>{t('login.next')}</button>
        </div>
      </form>
    );
  } else if (m === 'reg-company') {
    // Letzter Schritt: Firma, AGB, absenden (den Kurznamen der Firma bildet der Server).
    const termsText = t('login.acceptTerms').split(/(\{terms\}|\{privacy\})/);
    body = (
      <form onSubmit={handleRegister}>
        {header(t('login.regCompanyTitle'), t('login.regCompanySub'))}
        <div className="mt-7 space-y-4">
          <FloatingField label={t('login.companyName')} value={company} onChange={typed(setCompany)} autoComplete="organization"
                         onClick={retapFocus} autoFocus={focusNext} required error={fieldError} />
          <label className="flex items-start gap-3 text-[15px] text-[#d1d1d6]">
            <input type="checkbox" checked={agb} onChange={(e) => setAgb(e.target.checked)}
                   className="mt-1 h-5 w-5 rounded accent-white" />
            <span>
              {termsText.map((part, i) => part === '{terms}'
                ? <a key={i} href="/terms-of-use" target="_blank" rel="noreferrer" className="text-[#4f8cff] underline">{t('login.terms')}</a>
                : part === '{privacy}'
                  ? <a key={i} href="/privacy-policy" target="_blank" rel="noreferrer" className="text-[#4f8cff] underline">{t('login.privacy')}</a>
                  : <span key={i}>{part}</span>)}
            </span>
          </label>
          <button type="submit" disabled={loading || company.trim().length < 2 || !agb} className={PRIMARY}>
            {loading ? t('login.moment') : t('login.createAccount')}
          </button>
        </div>
      </form>
    );
  } else if (m === 'reg-done') {
    // Fuer jede Adresse derselbe Satz - ob es schon ein Konto gibt, steht nur in der Mail.
    body = (
      <>
        {header(t('login.regDoneTitle'), fill(t('login.regDoneSub'), { email: email.trim() }))}
        <div className="mt-8 space-y-4">
          <p className="text-[15px] leading-snug text-[#8e8e93]">{t('login.regDoneHint')}</p>
          <button type="button" disabled={loading} className={SECONDARY} onClick={() => { void resendRegistration(); }}>
            {loading ? t('login.moment') : t('login.resend')}
          </button>
        </div>
      </>
    );
  } else if (m === 'reg-confirm') {
    // Link aus der Mail: Passwort -> bestaetigt -> angemeldet (neue Adresse: das gewaehlte, bekannte: das bisherige).
    body = !signup ? (
      <>
        {header(t('login.signupTitle'), t('login.loadingInvite'))}
      </>
    ) : (
      <form onSubmit={handleConfirmSignup}>
        {header(t('login.signupTitle'), fill(t('login.signupSub'), { company: signup.company_name }))}
        <div className="mt-7 space-y-4">
          {emailField(true, false)}
          {passwordField(password, setPassword, t('login.password'), 'current-password', true)}
          <div className="flex justify-end"><button type="button" className={`${LINK} text-right`} onClick={() => switchMode('forgot', false)}>{t('login.forgot')}</button></div>
          <button type="submit" disabled={loading || !password} className={PRIMARY}>
            {loading ? t('login.moment') : t('login.signupButton')}
          </button>
        </div>
      </form>
    );
  } else if (m === 'invite' && declined) {
    body = (
      <>
        {header(t('login.setupTitle'), t('login.declined'))}
        <div className="mt-7 space-y-4">
          <button type="button" className={SECONDARY} onClick={() => switchMode('signin')}>{t('login.toLogin')}</button>
        </div>
      </>
    );
  } else if (m === 'invite') {
    const askName = !!invite && invite.multi_use && !invite.person_name;
    const companies = invite?.companies || [];
    body = !invite ? (
      <>
        {header(t('login.setupTitle'), t('login.loadingInvite'))}
      </>
    ) : (
      <form onSubmit={handleInvite}>
        {header(t('login.setupTitle'),
          invite.person_name
            ? fill(t(invite.has_account ? 'login.setupHelloAccount' : 'login.setupHello'), { name: invite.person_name })
            : invite.has_account ? t('login.hasAccountHint') : undefined)}
        <div className="mt-7 space-y-4">
          {emailField(true, false)}
          {askName && (
            <FloatingField label={t('login.yourName')} value={displayName} onChange={setDisplayName}
                           autoComplete="name" required />
          )}
          {invite.has_account ? (
            <>
              {passwordField(password, setPassword, t('login.password'), 'current-password', true)}
              <div className="flex justify-end"><button type="button" className={`${LINK} text-right`} onClick={() => switchMode('forgot', false)}>{t('login.forgot')}</button></div>
            </>
          ) : passwordPair(invite.password_min_length || PASSWORD_MIN_LENGTH)}
          {companies.length > 1 && (
            <div className="space-y-2" data-choose-company>
              <p className="text-[15px] text-[#8e8e93]">{t('login.chooseCompany')}</p>
              {companies.map((c) => (
                <button key={c.id} type="button" onClick={() => setOrgId(c.id)}
                        className={`${FIELD} text-left flex items-center justify-between`}
                        style={orgId === c.id ? { borderColor: '#ffffff' } : undefined}>
                  <span className="truncate">{c.name}</span>
                  {orgId === c.id && <span aria-hidden>✓</span>}
                </button>
              ))}
            </div>
          )}
          <button type="submit" disabled={loading} className={PRIMARY}>
            {loading ? t('login.moment') : t('login.setupButton')}
          </button>
          {!canDecline(invite) ? null : confirmDecline ? (
            <div className="space-y-3" data-decline-confirm>
              <p className="text-[15px] text-[#8e8e93]">{t('login.declineHint')}</p>
              <button type="button" disabled={loading} className={SECONDARY} onClick={() => { void handleDecline(); }}>
                {t('login.declineYes')}
              </button>
              <button type="button" className={LINK} onClick={() => setConfirmDecline(false)}>{t('login.declineNo')}</button>
            </div>
          ) : (
            <button type="button" className={LINK} onClick={() => setConfirmDecline(true)}>{t('login.decline')}</button>
          )}
        </div>
      </form>
    );
  } else if (m === 'forgot') {
    body = forgotSent ? (
      <>
        {header(t('login.forgotTitle'), fill(t('login.forgotSent'), { email }))}
        <div className="mt-7 space-y-4">
          <p className="text-[15px] text-[#8e8e93]">{t('login.forgotHint')}</p>
          <button type="button" className={PRIMARY} onClick={() => switchMode('signin')}>{t('login.toLogin')}</button>
        </div>
      </>
    ) : (
      <form onSubmit={handleForgot}>
        {header(t('login.forgotTitle'), t('login.forgotPrompt'))}
        <div className="mt-7 space-y-4">
          {emailField()}
          <button type="submit" disabled={loading || !isEmail(email)} className={PRIMARY}>
            {loading ? t('login.moment') : t('login.sendLink')}
          </button>
        </div>
      </form>
    );
  } else if (m === 'reset') {
    body = (
      <form onSubmit={handleReset}>
        {header(t('login.resetTitle'), t('login.resetPrompt'))}
        <div className="mt-7 space-y-4">
          {passwordPair(PASSWORD_MIN_LENGTH)}
          <button type="submit" disabled={loading} className={PRIMARY}>
            {loading ? t('login.moment') : t('login.setPassword')}
          </button>
        </div>
      </form>
    );
  } else {
    body = (
      <form onSubmit={handleLogin}>
        {header(t('login.passwordTitle'), (
          <>
            {email}
            <button type="button" onClick={back} className="relative ml-3 text-[15px] font-semibold text-[#4f8cff] after:absolute after:-inset-x-2 after:-inset-y-[12px] after:content-['']">
              {t('login.change')}
            </button>
          </>
        ), firmName)}
        {/* Die Adresse bleibt im Formular (Passwort-Manager, autoComplete), aber unsichtbar. */}
        <input type="email" value={email} readOnly autoComplete="username" className="hidden" />
        <div className="mt-7 space-y-4">
          {passwordField(password, setPassword, t('login.password'), 'current-password', true)}
          <div className="flex justify-end"><button type="button" className={`${LINK} text-right`} onClick={() => switchMode('forgot', false)}>{t('login.forgot')}</button></div>
          <button type="submit" disabled={loading || !password} className={PRIMARY}>
            {loading ? t('login.signingIn') : t('login.next')}
          </button>
        </div>
      </form>
    );
  }
  return body;
  };

  return (
    <div ref={shellRef} className="fixed inset-0 z-50 bg-black text-white overflow-hidden">
      <div className="absolute inset-0">
        {stack.map((m, i) => {
          const key = layerKey(i, m);
          return (
            <StepLayer key={key} initial={key === firstLayerKey.current} active={i === stack.length - 1}
                       register={(el) => { layerNodes.current[key] = el; }}>
              {stepBody(m, i === stack.length - 1)}
            </StepLayer>
          );
        })}
        {/* Toast unten im sichtbaren Ausschnitt (ueber der Tastatur): verschiebt nichts, blendet nach 3 s aus,
            Antippen schliesst frueher. */}
        {(notice || (error && !errorInline)) && (
          <div className="absolute left-0 right-0 px-5 pointer-events-none bottom-[calc(16px+env(safe-area-inset-bottom))]">
            <button type="button" onClick={() => { setError(''); setNotice(''); }}
                    className={`pointer-events-auto block w-full max-w-md mx-auto text-left p-4 rounded-2xl text-[15px] shadow-lg ${
                      notice ? 'bg-[#2c2c2e] text-[#f2f2f7]' : 'bg-[#3a1d1d] text-[#ff6b6b]'}`}>
              {notice || error}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginFlow;
